import { render } from "./outword.vue?vue&type=template&id=7d23ecad"
import script from "./outword.vue?vue&type=script&lang=js"
export * from "./outword.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__